import { useActiveQualificationsWithLicenses } from "@src/appV2/redesign/Documents/components/IndependentContractorBadge/hooks/useActiveQualificationsWithLicenses";
import { useState } from "react";

export enum ProfileWorkBadgesStep {
  INFO = "info",
  SELECT_ROLE = "select_role",
  SELECT_HEADSHOT = "select_headshot",
  BADGE_READY = "badge_ready",
}

export function useProfileWorkBadges() {
  const [step, setStep] = useState<ProfileWorkBadgesStep>(ProfileWorkBadgesStep.INFO);
  const [selectedQualificationId, setSelectedQualificationId] = useState<string | undefined>();
  const [workerHeadshotBase64, setWorkerHeadshotBase64] = useState<string | undefined>();

  const { data: activeQualifications, isLoading: isLoadingQualifications } =
    useActiveQualificationsWithLicenses();

  const selectedQualification = activeQualifications.find(
    (q) => q.qualification.id === selectedQualificationId
  );

  function handleQualificationSelect(qualificationId: string) {
    setSelectedQualificationId(qualificationId);
  }

  return {
    step,
    setStep,
    activeQualifications,
    isLoadingQualifications,
    selectedQualification,
    handleQualificationSelect,
    selectedQualificationId,
    workerHeadshotBase64,
    setWorkerHeadshotBase64,
  };
}
